import { render } from "./PedidoCadastro.vue?vue&type=template&id=46cda1b4&scoped=true&ts=true"
import script from "./PedidoCadastro.vue?vue&type=script&lang=ts"
export * from "./PedidoCadastro.vue?vue&type=script&lang=ts"

import "./PedidoCadastro.vue?vue&type=style&index=0&id=46cda1b4&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cda1b4"]])

export default __exports__